import {useSessionStorage} from '@aboutyou/storage';
import {useCallback} from 'react';

export const useIsHintCovered = () => {
  // TODO: Refactor useSessionStorage cases into a global UI provider https://aboutyou.atlassian.net/browse/AYFEP-3271
  const [value, setValue] = useSessionStorage<boolean>({
    key: 'is_shophint_covered',
    defaultValue: false,
  });

  const setIsHintCovered = useCallback(
    (status: boolean) => {
      setValue(status);
    },
    [setValue],
  );

  return {
    isHintCovered: value,
    setIsHintCovered,
  };
};
